module.exports = __webpack_public_path__ + "img/key-icon--grayscale400.1fc41408.svg";